import logger from 'loglevel';
import prefixer from 'loglevel-plugin-prefix';
logger.setLevel('info');
prefixer.reg(logger);
prefixer.apply(logger, {
    timestampFormatter: (date) => date.toISOString(),
});
export default logger;
//# sourceMappingURL=logger.js.map